<template>
    <activix-modal size="md" :opened="opened" @close="$emit('update:opened', false)">
        <template #header>
            <div class="text-lg text-center font-semibold text-gray-800">
                {{ $t('navs.supportModal.title') }}
            </div>
        </template>

        <template #body>
            <div class="space-y-2 py-1">
                <div class="flex items-center gap-4 rounded-xl p-4">
                    <div
                        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-100"
                    >
                        <icon
                            class="text-xl text-blue-600"
                            name="regular/headphones-customer-support"
                        />
                    </div>
                    <div class="self-center leading-relaxed text-gray-700">
                        {{ $t('navs.supportModal.contactPre') }}
                        <a
                            href="mailto:support@activix.ca"
                            class="font-medium text-blue-600 hover:underline"
                        >
                            support@activix.ca
                        </a>
                        {{ $t('navs.supportModal.contactMid') }}
                        <a
                            href="tel:18664306767"
                            class="whitespace-nowrap font-medium text-blue-600 hover:underline"
                            >{{ $t('navs.supportModal.contactPhone') }}</a
                        >
                        {{ $t('navs.supportModal.contactPost') }}
                    </div>
                </div>

                <div class="flex items-center gap-4 rounded-xl p-4">
                    <div
                        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-purple-100"
                    >
                        <icon class="text-xl text-purple-600" name="regular/book-open-2" />
                    </div>
                    <div class="self-center leading-relaxed text-gray-700">
                        {{ $t('navs.supportModal.trainingPre') }}
                        <a
                            href="https://fr.exp.activix.ca/enrollments"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="font-medium text-purple-600 hover:underline"
                            >{{ $t('navs.supportModal.trainingLink') }}</a
                        >.
                    </div>
                </div>

                <div class="flex items-center gap-4 rounded-xl p-4">
                    <div
                        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-100"
                    >
                        <icon class="text-xl text-red-600" name="regular/screen-1" />
                    </div>
                    <div class="self-center leading-relaxed text-gray-700">
                        {{ $t('navs.supportModal.youtubePre') }}
                        <a
                            href="https://www.youtube.com/@activix-crm"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="font-medium text-red-600 hover:underline"
                            >{{ $t('navs.supportModal.youtubeLink') }}</a
                        >{{ $t('navs.supportModal.youtubePost') }}
                    </div>
                </div>

                <div class="flex items-center gap-4 rounded-xl p-4">
                    <div
                        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-100"
                    >
                        <icon class="text-xl text-sky-700" name="regular/single-neutral-actions" />
                    </div>
                    <div class="self-center leading-relaxed text-gray-700">
                        {{ $t('navs.supportModal.linkedinPre') }}
                        <a
                            href="https://www.linkedin.com/company/activix/mycompany/"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="font-medium text-sky-700 hover:underline"
                            >{{ $t('navs.supportModal.linkedinLink') }}</a
                        >.
                    </div>
                </div>
            </div>
        </template>
    </activix-modal>
</template>

<script>
    export default {
        emits: ['update:opened'],

        props: {
            opened: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
